import { ticker } from "../utils/data";

const Ticker = () => (
  <section
    aria-label="Technologies I work with"
    className="border-b border-paper-300 bg-paper-100 py-6 overflow-hidden"
  >
    <div className="mx-auto max-w-shell px-6 lg:px-10">
      <p className="flex items-center gap-x-6 font-mono text-micro uppercase text-ink-500 whitespace-nowrap animate-marquee">
        {[...ticker, ...ticker].map((tech, i) => (
          <span key={`${tech}-${i}`} className="flex items-center gap-2.5 shrink-0">
            <span className="text-ink-300" aria-hidden>•</span>
            {tech}
          </span>
        ))}
      </p>
    </div>
  </section>
);

export default Ticker;
